/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { VoiceBundleCandidate } from '../../models/voice-bundle-candidate';

export interface FindVoiceSessionBundles$Params {
  organizationSiteKey: KeyType;
  voiceSessionKey: KeyType;
  last4: string;
}

export function findVoiceSessionBundles(http: HttpClient, rootUrl: string, params: FindVoiceSessionBundles$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VoiceBundleCandidate>>> {
  const rb = new RequestBuilder(rootUrl, findVoiceSessionBundles.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('voiceSessionKey', params.voiceSessionKey, {});
    rb.query('last4', params.last4, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<VoiceBundleCandidate>>;
    })
  );
}

findVoiceSessionBundles.PATH = '/organization-sites/{organizationSiteKey}/voice-sessions/{voiceSessionKey}/bundles';
